var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_2191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2398 0.0158691L8.39819 4.69497L9.47867 1.93427L14.2398 0.0158691Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.754395 0.0158691L6.54905 4.73925L5.52144 1.93427L0.754395 0.0158691Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1378 10.8622L10.582 13.433L13.9109 14.4206L14.8679 10.9192L12.1378 10.8622Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.137939 10.9192L1.08905 14.4206L4.41792 13.433L2.86218 10.8622L0.137939 10.9192Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23002 6.51854L3.30225 8.03205L6.60749 8.19038L6.49022 4.35962L4.23002 6.51854Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7641 6.51851L8.4747 4.31531L8.39819 8.19034L11.6978 8.03202L10.7641 6.51851Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 13.433L6.40229 12.3881L4.68794 10.9443L4.41797 13.433Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5918 12.3881L10.582 13.433L10.3062 10.9443L8.5918 12.3881Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.582 13.433L8.5918 12.3881L8.75041 13.7875L8.73269 14.3762L10.582 13.433Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 13.433L6.26731 14.3762L6.25549 13.7875L6.40229 12.3881L4.41797 13.433Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29644 10.0201L4.64087 9.4945L5.80908 8.91821L6.29644 10.0201Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69751 10.0201L9.18488 8.91821L10.359 9.4945L8.69751 10.0201Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4178 13.433L4.69958 10.8622L2.86206 10.9192L4.4178 13.433Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3003 10.8622L10.5821 13.433L12.1378 10.9192L10.3003 10.8622Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6978 8.03198L8.39819 8.19031L8.70361 10.0202L9.19098 8.91823L10.3651 9.49452L11.6978 8.03198Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64088 9.49452L5.815 8.91823L6.29646 10.0202L6.60749 8.19031L3.30225 8.03198L4.64088 9.49452Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30225 8.03198L4.68785 10.9443L4.64088 9.49452L3.30225 8.03198Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3649 9.49452L10.3062 10.9443L11.6977 8.03198L10.3649 9.49452Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60742 8.19031L6.29639 10.0202L6.68392 12.1791L6.77194 9.33619L6.60742 8.19031Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39807 8.19031L8.23975 9.32982L8.31005 12.1791L8.70348 10.0202L8.39807 8.19031Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7035 10.0201L8.31006 12.1791L8.59185 12.388L10.3062 10.9443L10.365 9.49451L8.7035 10.0201Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64087 9.49451L4.68783 10.9443L6.40219 12.388L6.68397 12.1791L6.29644 10.0201L4.64087 9.49451Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7328 14.3763L8.75052 13.7875L8.60372 13.648H6.39048L6.25549 13.7875L6.26731 14.3763L4.41797 13.433L5.06366 14.0026L6.37276 14.9841H8.62144L9.93645 14.0026L10.5821 13.433L8.7328 14.3763Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59178 12.3881L8.31 12.1791H6.68396L6.40217 12.3881L6.25537 13.7875L6.39036 13.648H8.6036L8.7504 13.7875L8.59178 12.3881Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4863 4.99888L14.9852 2.41563L14.2397 0.0158691L8.5918 4.53664L10.764 6.51844L13.8344 7.4872L14.5155 6.63249L14.2219 6.40471L14.6916 5.94247L14.3277 5.63856L14.7973 5.25214L14.4863 4.99888Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0146484 2.41563L0.513536 4.99888L0.196599 5.25214L0.666244 5.63856L0.308251 5.94247L0.777896 6.40471L0.484294 6.63249L1.15952 7.4872L4.22994 6.51844L6.40212 4.53664L0.754266 0.0158691L0.0146484 2.41563Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8344 7.48731L10.764 6.51855L11.6977 8.03206L10.3062 10.9444L12.1378 10.9192H14.8679L13.8344 7.48731Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23006 6.51855L1.15964 7.48731L0.137939 10.9192H2.86218L4.68789 10.9444L3.30229 8.03206L4.23006 6.51855Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39814 8.19033L8.5919 4.53669L9.48452 1.93433H5.52148L6.40229 4.53669L6.60758 8.19033L6.67817 9.34258L6.68408 12.1791H8.31011L8.32193 9.34258L8.39814 8.19033Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_2191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.6b6133e28e05a68ea116a3bba74ac293.svg";
export { ForwardRef as ReactComponent };